const GET_CORRETORAS = 'GET_CORRETORAS';
const NOT_FOUND = 'NOT_FOUND';

export { GET_CORRETORAS, NOT_FOUND };